// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "lucide-react" + "-" + "5b40827b4e3a23ec" + ".js";
};